<template lang="pug">
div
  slot(name="title")
  v-form(ref="form")
    v-row(no-gutters)
      v-col(cols="9")
        v-row
          v-col.pb-0(cols="4")
            div.text-sm.font-semibold.neutral500--text {{ $t('doctor') }}
          v-col.pb-0(cols="4")
            div.text-sm.font-semibold.neutral500--text {{ $t('service_type') }}
        template(v-for="(row, idx) in spRows")
          service-provider-row(v-model="servicesProviders" :key="`row-${row}`" @change="changeServicesProviders(servicesProviders)")
            template(#button)
              v-btn(v-if="servicesProviders.length > 1" :style="showAddMoreService(idx) ? '' : 'margin-top:10px;'" small icon @click="removeSpRow(idx)")
                v-icon(size="22") $yzi-trash-03
              y-button.ml-6(v-if="showAddMoreService(idx)" label="Add more service" underline button-class="px-0" prepend-icon="mdi-plus" icon-color="black" @click="spRows.push(row+1)")

      v-col(cols="3")
        div.text-sm.font-semibold.neutral500--text {{ $t('notes') }}
        v-textarea.text-sm.mt-2.round-xl(v-model="remarks" :placeholder="$t('notes_optional')" outlined rows="3" hide-details="auto")

    v-divider.my-8

    v-row
      v-col(:cols="['daily', 'weekly', 'monthly'].includes(frequency) ? '4' : '3'")
        v-row
          v-col
            div.text-sm.font-semibold.neutral500--text Appointment frequency
            v-select.round-xl.custom-select-style.mt-2(v-model="frequency" :items="frequencies" item-text="title" item-value="value" item-disabled="disabled" placeholder="Select frequency" :loading="false" @change="changeFrequency()" dense outlined hide-details="auto" append-icon="$yzi-chevron-down" :menu-props="{ offsetY: true, rounded: 'lg', contentClass: 'select-menu' }" height="48")
              template(#item="{ item, on, attrs }")
                v-list-item(v-on="on" v-bind="attrs" active-class="neutral100")
                  v-list-item-content
                    v-list-item-title
                      div
                        .text-sm(:class="attrs.disabled ? 'neutral400--text' : 'neutral700--text'") {{ item.title }}
                        .text-xs(:class="attrs.disabled ? 'neutral400--text' : 'neutral500--text'") {{ item.description }}
                  //- .text-xs.neutral500--text {{ attrs }}
          v-col(v-if="['daily', 'weekly', 'monthly'].includes(frequency)")
            v-row.mt-7(dense align="center")
              v-col.shrink
                div.text-sm.neutral700--text every
              v-col(cols="4")
                v-text-field.text-sm.round-xl.input-number(v-model="interval" outlined dense height="40" type="number" :rules="rules.not_empty" hide-details)
              v-col
                div.text-sm.neutral700--text {{ frequency === 'daily' ? 'day(s)' : frequency === 'weekly' ? 'week(s)' : 'month(s)' }}

      v-col(:cols="['daily', 'weekly', 'monthly'].includes(frequency) ? '8' : '9'")

        //- One-time
        v-row(v-if="!frequency")
          v-col(cols="4")
            set-appointment-date(v-model="selectedDate" :placeholder="$t('select_appointment_date')" :show-set-later="serviceCount === 1" hide-details="true" :loading="isFetchingDates" :disabled="disableDateOneTime" :required="!setLater" :picker-date.sync="pickerDate" :min-date="getMinDate()" :unavailable-dates="unavailableDates" :is-set-later.sync="setLater" @change="setDateOneTime(selectedDate)")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mb-2 Select date
          
          template(v-if="!setLater")
            v-col(cols="7" v-if="showSelectTimeRegular")
              div.text-sm.font-semibold.neutral500--text Select time
              template(v-if="isFetchingTimes")
                div.d-flex.mt-2
                  v-skeleton-loader.mx-1(v-for="n in 6" :key="`sl-${n}`" height="30" width="85" type="button" style="width: 85px;")
              v-row.mt-1(v-else dense)
                template(v-for="(slot, slotidx) in times")
                  v-col.pa-1(cols="2" :key="`slot-${slotidx}`")
                    div.pa-2.clickable(:style="isSelected(slot) ? activeBorder : inactiveBorder" @click="setTimeOneTime(slot)")
                      div.text-xs.neutral700--text.text-center {{ slot | displayTime2 }}
                template(v-if="!times.length")
                  v-col.pa-1(cols="4")
                    div.pa-2(:style="inactiveBorder")
                      div.text-xs.neutral700--text.text-center no available time slots
            v-col(cols="5" v-if="showSelectTimeCombo")
              combo-select-time(v-model="selectedTimeCombo" :loading="isFetchingTimes" :disabled="!selectedDate" @change="arrangeSessionsCombo(comboData, selectedTimeCombo)")
                template(#title)
                  div.text-sm.font-semibold.neutral500--text.mb-2 Configure appointment timing

        //- Daily
        v-row(v-if="frequency === 'daily'")
          v-col(cols="5")
            end-repeat(:end-type.sync="endType" :until.sync="repeatUntil" :count.sync="repeatCount")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mb-2 End repeat
          v-col(cols="6")
            div(style="width: 250px;")
              set-appointment-date(v-model="selectedDate" placeholder="Select date" show-set-later hide-details="true" :loading="isFetchingDates" :disabled="disableDateDaily" :required="!setLater" :picker-date.sync="pickerDate" :min-date="getMinDate()" :unavailable-dates="unavailableDates" :is-set-later.sync="setLater"  @change="setDate(selectedDate)")
                template(#title)
                  div.text-sm.font-semibold.neutral500--text.mb-2 Select starting date
            recurring-select-time.mt-4(v-if="!setLater" v-model="selectedTimeRecurring" :loading="isFetchingRecurringTimes" :disabled="!selectedDate" @change="arrangeSessions(recurringData, selectedTimeRecurring)")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mb-2 Configure appointment timing

        //- Weekly
        v-row(v-if="frequency === 'weekly'")
          v-col(cols="6")
            div.text-sm.font-semibold.neutral500--text On what day of the week you wish to reoccur the appointment?
            v-row.mt-2(dense)
              v-col(v-for="day in daysWeek" :key="day.value")
                v-avatar.clickable(:color="day.selected ? 'neutral700' : 'neutral300'" size="35" @click="day.selected = !day.selected")
                  span.text-md(:class="day.selected ? 'neutral100--text' : 'neutral500--text'") {{ day.text }}
              v-col
                v-avatar(color="transparent" size="35")

            end-repeat(:end-type.sync="endType" :until.sync="repeatUntil" :count.sync="repeatCount")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mt-8.mb-2 End repeat

          v-col
            div(style="width: 250px;")
              set-appointment-date(v-model="selectedDate" placeholder="Select date" show-set-later hide-details="true" :loading="isFetchingDates" :disabled="disableDateWeekly" :required="!setLater" :picker-date.sync="pickerDate" :min-date="getMinDate()" :unavailable-dates="unavailableDates" :is-set-later.sync="setLater" @change="setDate(selectedDate)")
                template(#title)
                  div.text-sm.font-semibold.neutral500--text.mb-2 Select starting date
            recurring-select-time.mt-4(v-if="!setLater" v-model="selectedTimeRecurring" :loading="isFetchingRecurringTimes" :disabled="!selectedDate" @change="arrangeSessions(recurringData, selectedTimeRecurring)")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mb-2 Configure appointment timing

        //- Monthly
        v-row(v-if="frequency === 'monthly'")
          v-col(cols="6")
            div.text-sm.font-semibold.neutral500--text On what day of the month you wish to reoccur the appointment?
            v-radio-group.mt-2(v-model="recurringType" :rules="rules.not_empty" hide-details)
              v-radio(value="byMonthDay" color="neutral700")
                template(v-slot:label)
                  div.d-flex.align-center.font-normal
                    div.text-sm.neutral700--text On day
                    div.ml-3(style="width: 120px;")
                      y-select(v-model="bymonthday" :items="daysNum()" item-text="text" item-value="value" placeholder="15" :rules="recurringType === 'byMonthDay' ? rules.not_empty_select : []" hide-details small)
                      //- v-text-field.text-sm.round-xl.input-number(v-model="bymonthday" outlined dense height="40" type="number" :rules="recurringType === 'byMonthDay' ? rules.not_empty : []" hide-details)

              v-radio.mt-1(value="bySetPos" color="neutral700")
                template(v-slot:label)
                  div.d-flex.align-center.font-normal
                    div.text-sm.neutral700--text On the
                    div.ml-3(style="width: 120px;")
                      y-select(v-model="bysetpos" :items="setposlist" item-text="text" item-value="value" placeholder="First" :rules="recurringType === 'bySetPos' ? rules.not_empty_select : []" hide-details small)
                    div.ml-3(style="width: 120px;")
                      y-select(v-model="byday" :items="daysMonth" item-text="text" item-value="value" placeholder="Mon" :rules="recurringType === 'bySetPos' ? rules.not_empty_select : []" hide-details small)

            end-repeat(:end-type.sync="endType" :until.sync="repeatUntil" :count.sync="repeatCount")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mt-6.mb-2 End repeat

          v-col
            div(style="width: 250px;")
              set-appointment-date(v-model="selectedDate" placeholder="Select date" show-set-later hide-details="true" :loading="isFetchingDates" :disabled="disableDateMonthly" :required="!setLater" :picker-date.sync="pickerDate" :min-date="getMinDate()" :unavailable-dates="unavailableDates" :is-set-later.sync="setLater" @change="setDate(selectedDate)")
                template(#title)
                  div.text-sm.font-semibold.neutral500--text.mb-2 Select starting date
            recurring-select-time.mt-4(v-if="!setLater" v-model="selectedTimeRecurring" :loading="isFetchingRecurringTimes" :disabled="!selectedDate" @change="arrangeSessions(recurringData, selectedTimeRecurring)")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mb-2 Configure appointment timing

        //- Yearly
        v-row(v-if="frequency === 'yearly'")
          v-col(cols="6")
            div.text-sm.font-semibold.neutral500--text On what day of the year you wish to reoccur the appointment?
            div.d-flex.align-center.mt-3
              div.text-sm.neutral700--text.mr-3 On date
              set-appointment-date(v-model="selectedDate" placeholder="Select date" hide-details="true" :loading="isFetchingDates" :picker-date.sync="pickerDate" :min-date="getMinDate()" :unavailable-dates="unavailableDates" @change="setDate(selectedDate)")

            end-repeat(:end-type.sync="endType" :until.sync="repeatUntil" :count.sync="repeatCount" @change="setDate(selectedDate)")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mt-6.mb-2 End repeat

          v-col
            recurring-select-time(v-model="selectedTimeRecurring" :loading="isFetchingRecurringTimes" :disabled="!selectedDate" @change="arrangeSessions(recurringData, selectedTimeRecurring)")
              template(#title)
                div.text-sm.font-semibold.neutral500--text.mb-2 Configure appointment timing

        //- Custom
        v-row(v-if="frequency === 'custom'")
          v-col(cols="5")
            div.text-sm.font-semibold.neutral500--text How many time(s) you want to repeat this appointment?
            div.d-flex.align-center.font-normal.mt-3
              div.text-sm.neutral700--text Repeat
              div.ml-3(style="width: 50px;")
                v-text-field.text-sm.round-xl.input-number(v-model="repeatCount" outlined dense height="40" type="number" :rules="rules.has_quantity" hide-details @change="customDateArrange(repeatCount)")
              div.text-sm.neutral700--text.ml-3 time(s)
            div.text-xs.danger500--text.mt-1(v-if="repeatCount > 50") The maximum allowed repeat time is 50.

          v-col
            div.text-sm.font-semibold.neutral500--text Select date and time for each occurrences
            div.mt-4
              div.d-flex.align-center.my-1(v-for="(session, idx) in sessions" :key="`ses-${idx}`")
                v-avatar.mr-2(color="neutral700" size="5")
                div.text-sm.neutral700--text Appointment {{ idx + 1 }} {{ session.start ? `: ${$options.filters.humanizeDate(session.start.substr(0, 10))} at ${$options.filters.displayTime2(session.start.substr(-8))}` : session.preset_date ? `: ${$options.filters.humanizeDate(session.preset_date)}` : '' }}
              
            y-button.mt-2(label="Choose date and time" size="sm" underline button-class="px-0" :disabled="disableDateCustom" @click="customDateArrange(repeatCount, true)")

  .dialogs
    set-preferred-time-dialog(v-if="showSelectTimeDialog" :open.sync="showSelectTimeDialog")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import ServiceProviderRow from '@/components/clinic/appointment/advance/ServiceProviderRow.vue'
import SetAppointmentDate from '@/components/clinic/appointment/advance/SetAppointmentDate.vue'
import EndRepeat from '@/components/clinic/appointment/advance/EndRepeat.vue'
import RecurringSelectTime from '@/components/clinic/appointment/advance/RecurringSelectTime.vue'
import ComboSelectTime from '@/components/clinic/appointment/advance/ComboSelectTime.vue'
import SetPreferredTimeDialog from '@/components/clinic/appointment/advance/SetPreferredTimeDialog.vue'

export default {
  components: { ServiceProviderRow, SetAppointmentDate, EndRepeat, RecurringSelectTime, ComboSelectTime, SetPreferredTimeDialog },
  data () {
    return {
      isFetchingDates: false,
      isFetchingTimes: false,
      isFetchingRecurringTimes: false,
      showSelectTimeDialog: false,
      setLater: false,
      selectedDate: null,
      selectedTime: null,
      selectedTimeRecurring: null,
      selectedTimeCombo: null,
      selectedService: null,
      pickerDate: null,
      endType: null,
      recurringType: null,
      repeatUntil: null,
      repeatCount: null,
      frequency: null,
      nextAvailibility: null,
      bymonth: null,
      bymonthday: null,
      bysetpos: null,
      byday: null,
      remarks: null,
      interval: null,
      spRows: [0],
      servicesProviders: [],
      unavailableDates: [],
      times: [],
      sessions: [],
      recurringData: {},
      comboData: {},
      setposlist: [
        { text: 'First', value: 1 },
        { text: 'Second', value: 2 },
        { text: 'Third', value: 3 },
        { text: 'Forth', value: 4 },
        { text: 'Last', value: -1 },
      ],
      daysMonth: [
        { text: 'Sun', value: 'sun' },
        { text: 'Mon', value: 'mon' },
        { text: 'Tue', value: 'tue' },
        { text: 'Wed', value: 'wed' },
        { text: 'Thu', value: 'thu' },
        { text: 'Fri', value: 'fri' },
        { text: 'Sat', value: 'sat' },
      ],
      daysWeek: [
        { text: 'S', value: 'sun', selected: false },
        { text: 'M', value: 'mon', selected: false },
        { text: 'T', value: 'tue', selected: false },
        { text: 'W', value: 'wed', selected: false },
        { text: 'T', value: 'thu', selected: false },
        { text: 'F', value: 'fri', selected: false },
        { text: 'S', value: 'sat', selected: false },
      ],
      frequencies: [
        { title: 'One-time', description: 'Plan one single visit.', value: null, disabled: false },
        { title: 'Repeat daily', description: 'Plan a visit for every day.', value: 'daily', disabled: false },
        { title: 'Repeat weekly', description: 'Plan a visit for every week.', value: 'weekly', disabled: false },
        { title: 'Repeat monthly', description: 'Plan a visit for each month.', value: 'monthly', disabled: false },
        { title: 'Repeat yearly', description: 'Plan a visit for once a year.', value: 'yearly', disabled: false },
        { title: 'Custom', description: 'Plan a visit for every week.', value: 'custom', disabled: false },
      ],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required', v => v <= 50 || 'number must less or equal 50'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
      activeBorder: {
        border: '2px solid var(--v-info500)',
        background: '#EEEEEE',
        borderRadius: '8px',
        padding: '2px'
      },
      inactiveBorder: {
        border: '2px solid #EEEEEE',
        background: '#EEEEEE',
        borderRadius: '8px',
        padding: '2px'
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    detailsData () {
      return {
        services_providers: this.servicesProviders,
        recurring_data: this.recurringData,
        combo_data: this.comboData,
        sessions: this.sessions,
        frequency: this.frequency,
        remarks: this.remarks,
        provider_count: this.providerCount,
        service_count: this.serviceCount,
      }
    },
    providerCount () {
      let count = 0
      let checkCount = this.calcProviderCount(this.servicesProviders)
      if (checkCount > 0) {
        count = checkCount
      }
      return count
    },
    serviceCount () {
      let count = 0
      let checkCount = this.calcServiceCount(this.servicesProviders)
      if (checkCount > 0) {
        count = checkCount
      }
      return count
    },
    showSelectTimeRegular () {
      let show = false
      if (this.selectedDate && this.serviceCount === 1 && this.providerCount === 1) {
        show = true
      }
      return show
    },
    showSelectTimeCombo () {
      let show = false
      if (this.selectedDate && (this.serviceCount > 1 || this.providerCount > 1)) {
        show = true
      }
      return show
    },
    disableDateOneTime () {
      let disable = true
      if (this.serviceCount && !this.hasEmptyRow) {
        return false
      }
      return disable
    },
    disableDateDaily () {
      let disable = true
      if (this.interval && this.serviceCount && this.endType && (this.repeatCount || this.repeatUntil)) {
        return false
      }
      return disable
    },
    disableDateWeekly () {
      let disable = true
      if (this.interval && this.serviceCount && this.endType && (this.repeatCount || this.repeatUntil) && this.daysWeek.filter(f => f.selected).length) {
        return false
      }
      return disable
    },
    disableDateMonthly () {
      let disable = true
      if (this.interval && this.serviceCount && this.endType && (this.repeatCount || this.repeatUntil) && (this.bymonthday || (this.bysetpos && this.byday))) {
        return false
      }
      return disable
    },
    disableDateCustom () {
      let disable = true
      if (this.repeatCount && this.serviceCount) {
        return false
      }
      return disable
    },
    hasEmptyRow () {
      let check = this.servicesProviders.find(f => !f.service || !f.provider)
      if (check) {
        return true
      }
      return false
    }
  },
  watch: {
    detailsData: {
      deep: true,
      handler (val) {
        this.$store.commit('clinic/updateTempAppointmentDetails', val)
      } 
    },
    providerCount (val) {
      if (val > 1) {
        this.frequencies.filter(f => f.value).map(m => m.disabled = true)
        this.frequency = null
      } else {
        this.frequencies.map(m => m.disabled = false)
      }
    },
    pickerDate (val) {
      if (!val) { return }
      if (this.providerCount === 1 && this.serviceCount) {
        let services = this.servicesProviders.filter(f => f.service).map(m => m.service).join()
        let provider = this.servicesProviders.filter(f => f.provider)[0].provider
        this.fetchUnavailableDates(provider, services, val)
      } else if (this.providerCount && this.serviceCount) {
        this.fetchComboUnavailableDates(this.servicesProviders, val)
      }
    }
  },
  mounted () {
    this.interval = '1'
    this.repeatCount = '5'
    this.repeatUntil = this.lastDayOfTheYear()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchUnavailableDates (provider, services, yearMonth) {
      this.times = []
      this.isFetchingDates = true
      let params = { services: services, provider: provider }
      if (yearMonth) {
        params.year = yearMonth.substr(0, 4),
        params.month = yearMonth.substr(-2)
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/block_dates`, { params })
        .then(resp => {
          this.unavailableDates = resp.data
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingDates = false
        })
    },
    async fetchComboUnavailableDates (rows, yearMonth) {
      this.times = []
      this.isFetchingDates = true
      let unavail = []
      for (let i = 0; i < rows.length; i++) {
        let error = false
        let service = rows[i].service
        let provider = rows[i].provider
        let params = { service, provider }
        if (yearMonth) {
          params.year = yearMonth.substr(0, 4),
          params.month = yearMonth.substr(-2)
        }
        const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
        await this.$axios.get(`/clinics/${companySlug}/block_dates`, { params })
          .then(resp => {
            if (resp.data && resp.data.length) {
              for (let j = 0; j < resp.data.length; j++) {
                if (!unavail.includes(resp.data[j])) {
                  unavail.push(resp.data[j])
                }
              }
            }
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data?.detail) {
              message = err.response.data.detail
            }
            this.showMessage(['error', message])
            error = true
          })
        if (error) {
          break
        }
      }
      this.unavailableDates = unavail
      this.isFetchingDates = false
    },
    fetchTimes () {
      if (this.providerCount === 0 || this.serviceCount === 0) {
        return
      }
      this.selectedTime = null
      this.isFetchingTimes = true
      let services = this.servicesProviders.map(m => m.service).join()
      let provider = this.servicesProviders[0].provider
      let params = {
        services: services || null,
        date: this.selectedDate || null
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/providers/${provider}/available_times`, { params })
        .then((resp) => {
          this.times = resp.data.times
          this.nextAvailibility = resp.data.next_availability
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingTimes = false
        })
    },
    fetchRecurringTimes () {
      if (!this.servicesProviders.length || !this.servicesProviders[0].provider || !this.servicesProviders[0].service ) {
        return
      }
      this.selectedTimeRecurring = null
      this.isFetchingRecurringTimes = true
      let payload = {
        dtstart: this.selectedDate || this.todayDate(),
        freq: this.frequency,
        interval: this.interval,
        provider: this.servicesProviders[0].provider,
        services: this.servicesProviders.map(m => m.service)
      }
      if (this.endType === 'count') { payload.count = this.repeatCount }
      if (this.endType === 'until') { payload.until = this.repeatUntil }
      if (this.frequency === 'weekly') { payload.byday = this.daysWeek.filter(f => f.selected).map(m => m.value) }
      if (this.frequency === 'monthly') { 
        if (this.recurringType === 'byMonthDay') { payload.bymonthday = this.bymonthday }
        else if (this.recurringType === 'bySetPos') {
          payload.bysetpos = this.bysetpos
          payload.byday = [this.byday]
        }
      }
      if (this.frequency === 'yearly') {
        payload.dtstart = this.todayDate(),
        payload.bymonthday = this.selectedDate.substr(-2)
        payload.bymonth = this.selectedDate.substr(5,2)
        if (!this.endType) {
          payload.count = 1
        }
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.post(`/clinics/${companySlug}/appointments/recur_slots`, payload)
        .then(resp => {
          this.recurringData = resp.data
          this.arrangeSessions(resp.data)
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingRecurringTimes = false
        })
    },
    fetchComboTimes () {
      if (!this.servicesProviders.length || !this.servicesProviders[0].provider || !this.servicesProviders[0].service ) {
        return
      }
      this.selectedTimeCombo = null
      this.isFetchingTimes = true
      let sessions = this.servicesProviders.map(m => {
        return {
          provider: m.provider,
          services: [m.service]
        }
      })
      let payload = {
        date: this.selectedDate || this.todayDate(),
        sessions: sessions
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.post(`/clinics/${companySlug}/appointments/combo_slots`, payload)
        .then(resp => {
          this.comboData = resp.data
          this.arrangeSessionsCombo(resp.data)
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingTimes = false
        })
    },
    changeServicesProviders (val) {
      this.selectedDate = null
      this.selectedTime = null
      this.selectedTimeRecurring = null
      if (this.calcProviderCount(val)) {
        if (this.calcProviderCount(val) === 1 && this.calcServiceCount(val)) {
          let services = val.filter(f => f.service).map(m => m.service).join()
          let provider = val.filter(f => f.provider)[0].provider
          this.fetchUnavailableDates(provider, services, this.pickerDate)
        } else if (this.calcProviderCount(val) && this.calcServiceCount(val)) {
          let sprows = val.filter(f => f.service && f.provider)
          this.fetchComboUnavailableDates(sprows, this.pickerDate)
        } else {
          this.unavailableDates = []
        }
      }
    },
    arrangeSessionRegular () {
      let objSession = {
        provider: this.servicesProviders[0].providerDetails,
        services: this.servicesProviders.map(m => m.serviceDetails)
      }
      if (!this.setLater && this.selectedTime) {
        objSession.start = `${this.selectedDate} ${this.selectedTime}`
      }
      this.sessions = [objSession]
    },
    arrangeSessions (data, selectedTime) {
      let sessions = []
      data.dates.forEach(session => {
        let objSession = {
          provider: this.servicesProviders[0].providerDetails,
          services: this.servicesProviders.map(m => m.serviceDetails),
        }
        if (selectedTime && selectedTime.dates.includes(session)) {
          objSession.start = `${session} ${selectedTime.time}`
        } else {
          objSession.preset_date = session
        }
        sessions.push(objSession)
      })
      this.sessions = sessions
    },
    arrangeSessionsCombo (data, selectedTime) {
      let sessions = []
      this.servicesProviders.forEach(session => {
        let objSession = {
          provider: session.providerDetails,
          services: [session.serviceDetails],
        }
        if (selectedTime && selectedTime.services.find(f => f.id === session.service)?.flag) {
          objSession.start = `${data.date} ${selectedTime.services.find(f => f.id === session.service).time}`
        } else {
          objSession.preset_date = data.date
        }
        sessions.push(objSession)
      })
      this.sessions = sessions
    },
    customDateArrange (count, open) {
      if (this.sessions.length === count) {
        this.showSelectTimeDialog = true
        return
      }
      let sessions = []
      for (let i = 0; i < count; i++ ) {
        let objSession = {
          provider: this.servicesProviders[0].providerDetails,
          services: this.servicesProviders.map(m => m.serviceDetails),
        }
        sessions.push(objSession)
      }
      this.sessions = sessions
      this.showSelectTimeDialog = open
    },
    getMinDate () {
      // if (this.selectedService && (this.selectedService.preparation_time_unit === 'days' || this.selectedService.preparation_time_unit === 'weeks' || this.selectedService.preparation_time_unit === 'months')) {
      //   let days = 0
      //   let weeks = 0
      //   let months = 0
      //   if (this.selectedService.preparation_time_unit === 'days') {
      //     days = this.selectedService.preparation_time_value
      //   } else if (this.selectedService.preparation_time_unit === 'weeks') {
      //     weeks = this.selectedService.preparation_time_value
      //   } else if (this.selectedService.preparation_time_unit === 'months') {
      //     months = this.selectedService.preparation_time_value
      //   }
      //   let date = DateTime.local()
      //   date = date.plus({days: days, weeks: weeks, months: months})
      //   return date.toFormat('yyyy-MM-dd')
      // } else {
      //   const today = new Date()
      //   const year = today.getFullYear()
      //   const month = String(today.getMonth() + 1).padStart(2, '0')
      //   const day = String(today.getDate()).padStart(2, '0')
      //   return `${year}-${month}-${day}`;
      // }
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`;
    },
    calcProviderCount (val) {
      let count = 0
      let sprows = val.filter(f => f.provider && f.service)
      if (sprows.length) {
        let providers = []
        sprows.forEach(row => {
          if (!providers.includes(row.provider)) {
            providers.push(row.provider)
          }
        })
        count = providers.length
      }
      return count
    },
    calcServiceCount (val) {
      let count = 0
      let sprows = val.filter(f => f.provider && f.service)
      if (sprows.length) {
        let services = []
        sprows.forEach(row => {
          if (!services.includes(row.service)) {
            services.push(row.service)
          }
        })
        count = services.length
      }
      return count
    },
    setDateOneTime (value) {
      if (this.serviceCount === 1 && this.providerCount === 1) {
        this.setDate(value || this.todayDate())
        this.arrangeSessionRegular()
      } else {
        this.setDate(value || this.todayDate())
      }
    },
    setTimeOneTime (value) {
      this.selectSlot(value)
      this.arrangeSessionRegular()
    },
    setDate (date) {
      if (!date) {
        return
      }
      if (this.providerCount === 1) {
        if (this.serviceCount === 1 && !this.frequency) {
          this.fetchTimes()
          return
        } else if (this.frequency) {
          this.fetchRecurringTimes()
          return
        }
      }
      this.fetchComboTimes()
    },
    selectSlot (slot) {
      this.selectedTime = slot
    },
    isSelected (slot) {
      if (slot === this.selectedTime) {
        return true
      }
      return false
    },
    showAddMoreService (idx) {
      if (this.servicesProviders[idx] && this.servicesProviders[idx].service && this.servicesProviders[idx].provider) {
        if (this.spRows.length === (idx + 1)) {
          return true
        }        
      }
      return false
    },
    removeSpRow (idx) {
      this.spRows.splice(idx, 1)
      this.servicesProviders.splice(idx, 1)
      this.changeServicesProviders(this.servicesProviders)
    },
    changeFrequency () {
      this.recurringData = {}
    },
    todayDate () {
      return DateTime.local().toFormat('yyyy-MM-dd')
    },
    lastDayOfTheYear () {
      return DateTime.local().endOf('year').toFormat('yyyy-MM-dd')
    },
    daysNum () {
      let nums = []
      for (let i = 1; i <= 31; i++) {
        let numsObj = { text: i, value: i }
        nums.push(numsObj)
      }
      nums.push({ text: 'last', value: -1 })
      return nums
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .input-number {
    text-align-last: center;
  }
  .custom-select-style .v-input__icon {
    min-width: 22px;
    width: 22px;
    margin-top: 4px;
  }
  .v-skeleton-loader__button {
    width: 85px;
  }
}
</style>